import css from './Toggle.module.css'

interface ToggleProps {
    checked: boolean
    onChange: (checked: boolean) => void
}

const Toggle = ({checked, onChange}: ToggleProps) => {
    return (
        <div
            className={[css.track, checked ? css.on : ''].filter(Boolean).join(' ')}
            onClick={() => onChange(!checked)}
        >
            <div className={css.thumb} />
        </div>
    )
}

export default Toggle
